import PinIndicator from '@/pages/join/components/PinIndicator';
import PinNumberPad from '@/pages/join/components/PinNumberPad';
import { observer } from 'mobx-react-lite';
import PinGuideTextArea from './PinGuideTextArea';
import clsx from 'clsx';

interface IProps {
    pin: string;
    isPinCheckFailed: boolean;
    pinStep: 'CHECK' | 'NEW' | 'CONFIRM';
    isNotMatchPin: boolean;
    isPinChangeSuccessModalOpen: boolean;
    onClickNumberBtn: (number: string) => void;
    OnClickDeleteBtn: () => void;
    onClickAllClearBtn: () => void;
    onClickPinChangeSuccessModalConfirm: () => void;
}

const PinSettingView = observer(
    ({
        pin,
        isPinCheckFailed,
        pinStep,
        isNotMatchPin,
        isPinChangeSuccessModalOpen,
        onClickNumberBtn,
        OnClickDeleteBtn,
        onClickAllClearBtn,
        onClickPinChangeSuccessModalConfirm,
    }: IProps) => {
        return (
            <div className="page-content pin-content">
                <div className="pin-header">
                    <h1 className="pin-title heading-4 font-bold">{'PIN 비밀번호 입력'}</h1>
                    {pinStep === 'CHECK' && (
                        <p className="pin-subtitle text-sm font-semibold">{'기존 PIN 비밀번호를 입력해주세요.'}</p>
                    )}
                    {pinStep === 'NEW' && (
                        <p className="pin-subtitle text-sm font-semibold">{'새로운 PIN 비밀번호를 6자리로 입력해주세요.'}</p>
                    )}
                    {pinStep === 'CONFIRM' && (
                        <p className="pin-subtitle text-sm font-semibold">{'다시 한번 입력해주세요.'}</p>
                    )}
                </div>
                <PinIndicator pin={pin} />
                <PinGuideTextArea pinStep={pinStep} isPinCheckFailed={isPinCheckFailed} isNotMatchPin={isNotMatchPin} />
                <PinNumberPad
                    onClickNumberBtn={onClickNumberBtn}
                    OnClickDeleteBtn={OnClickDeleteBtn}
                    onClickAllClearBtn={onClickAllClearBtn}
                />

                {/* PIN 변경 성공 모달 */}
                <div className={clsx('modal-overlay', !isPinChangeSuccessModalOpen && 'hidden')} id="pinChangeSuccessModal">
                    <div className="modal-content modal-medium">
                        <button type="button" className="modal-close" onClick={onClickPinChangeSuccessModalConfirm}>
                            <img src="./images/close-icon.png" alt="닫기" className="modal-close-icon" />
                        </button>

                        <div className="modal-body">
                            <div className="modal-icon-warning">
                                <img src="./images/success-icon.png" alt="성공 아이콘" className="modal-icon" />
                            </div>

                            <h2 className="modal-warning-title text-lg font-bold">PIN 비밀번호가 재설정되었습니다.</h2>

                            <button
                                type="button"
                                className="modal-button text-lg font-semibold"
                                onClick={onClickPinChangeSuccessModalConfirm}
                            >
                                확인
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    },
);

export default PinSettingView;